import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragulaModule } from 'ng2-dragula';
import { HelperRoutingModule } from './helper-routing.module';
import { DeliveryPartnerMapComponent } from './delivery-partner-map/delivery-partner-map.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OrderingPartnerMapComponent } from './ordering-partner-map/ordering-partner-map.component';
import { RiderQrCodeComponent } from './rider-qr-code/rider-qr-code.component';
import { QRCodeModule } from 'angularx-qrcode';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { DsAttendanceViewComponent } from './ds-attendance-view/ds-attendance-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { MyPipesModule } from '../../service/serviceModule';
import { DpDatePickerModule } from 'ng2-date-picker';
import { FilterDeleteTemplateComponent } from './filter-delete-template/filter-delete-template.component';

@NgModule({
  imports: [
    CommonModule,
    HelperRoutingModule,
    DragulaModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    QRCodeModule,
    TranslateModule,
    MyPipesModule,
    DpDatePickerModule
  ],
  declarations: [DeliveryPartnerMapComponent, OrderingPartnerMapComponent, RiderQrCodeComponent, ResetPasswordComponent, DsAttendanceViewComponent, FilterDeleteTemplateComponent],
  exports: [RiderQrCodeComponent]
})
export class HelperModule { }
